import InfinityGraph from './Graph'
const amounts = [
  {timestamp: 1622408296, amount:0.003241954979188634},
  {timestamp: 1621872000, amount: 0.003241954979188634},
  {timestamp: 1621803496, amount: 0.003241954979188634}
]
export function App(){

  return <InfinityGraph
  height={36}
width={130}
                  amounts={amounts}
                  decimals={2}
                  title="Balance"
                  base={55.5}
                  opacity={0.3}
                  fontFamily="Arial"
                  showDetailsGraph={false}
                  showVertical={false}
                  showHover={false}
                  baseChange={5.55}
                  showVertical={false}
                  showLines={false}
                  showTime={false}
                  showAmounts={false}
                  currency={{
                    symbol:"$",
                    rate:1,
                    decimals:2
                  }}
                  color={{
                    font_second:"#ff00ff",
                    background_thr:"#0000FF",
                    background:"#FFEEFF"
                  }}
                  />



}
